'use strict'

export const formatInputValue = (value: string) => {
  const newValue = value
    .replaceAll(',', '.')
    .replaceAll(' ', '')
    .replaceAll('.', '')
    .trim();

  return newValue;
};
